import styled from 'styled-components';

import { Button } from 'components/ui';

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const PromptContainer = styled.div.attrs({
  'data-testid': 'notification-subscription-prompt',
})`
  color: ${({ theme }) => theme.headerColor};
  max-width: 90%;
`;

export const CheckboxLabel = styled.span`
  font-size: 0.75rem;
  padding-top: 0.25rem;
  color: ${({ theme }) => theme.secondaryTextColor};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
`;
